module.exports = __webpack_public_path__ + "static/media/doi2bib-logo.3925db2e.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/components/doi2bib-logo.png
// module id = 93
// module chunks = 0